import { ref as i, watch as b } from "vue";
function E(u) {
  const l = i(u == null ? void 0 : u.isEditable);
  return b(
    () => u,
    () => {
      if (!u) return !1;
      u.on("update", ({ editor: f }) => {
        l.value = f.isEditable;
      });
    },
    { immediate: !0 }
  ), { isEditable: l };
}
export {
  E as useIsEditable
};
